<template>
  <v-dialog
    :value="open"
    content-class="clipDialogA_dialog"
    max-width="395px"
    @click:outside="handleCloseRequest"
    @keydown.esc="handleCloseRequest"
  >
    <v-btn
      icon
      class="clipDialogA_dialog-closeIcon"
      tabindex="-1"
      @click="$emit('onClose')"
    >
      <v-icon color="darken-2"> mdi-close </v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="clipDialogA_dialog-title">
        <span>{{ title }}</span>
      </v-card-title>

      <v-card-text class="clipDialogA_dialog-text">
        <v-container class="clipDialogA_dialog-container">
          <v-divider />
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <slot />
            </v-col>
          </v-row>
          <v-divider />
        </v-container>
      </v-card-text>

      <v-card-actions class="clipDialogA_dialog-actions">
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ClipDialogA',
  props: {
    open: {
      type: Boolean,
    },
    title: {
      type: String,
      default: () => null,
    },
  },
  methods: {
    handleCloseRequest(e) {
      if (e) {
        e.preventDefault?.();
        e.stopPropagation?.();
      }
      this.$emit('onClose');
    },
  },
};
</script>

<style lang="scss">
.clipDialogA {
  .v-btn {
    margin-top: 10px;
    &:not(.v-btn--round).v-size--x-small {
      padding-left: 8px;
      padding-right: 8px;
      &.v-btn--outlined {
        padding-left: 7px;
        padding-right: 7px;
        color: #989898;
        border-color: #989898;
      }
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
  .v-dialog > .v-card > .v-card__title {
    padding: 0;
  }
  &_dialog {
    border-radius: 10px;
    position: relative;
    &-cancel {
      color: #666 !important;
    }
    &-btn {
      width: 120px;
      font-size: 14px !important;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
    }
    &-closeIcon {
      &.v-btn {
        &.v-btn--icon.v-size--default {
          position: absolute;
          right: 3px;
          top: 3px;
          z-index: 1;
        }

        .v-icon {
          margin-right: 0;
          font-size: 20px;
          color: #999;
          font-weight: bold;
        }

        &:not(.v-btn--text):not(.v-btn--outlined):hover:before,
        &.theme--light:hover::before {
          opacity: 0;
        }
      }
    }
    &-container {
      padding: 0 !important;
      .v-divider {
        border-color: #ccc;
      }
    }
    &-content {
      margin: 20px 0;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
    }
    &-actions {
      margin-top: 20px;
    }
    &-text {
      padding: 0 !important;
      margin-top: 20px;
    }
    &-title {
      &.v-card__title {
        padding: 0 !important;
      }
      span {
        font-family: 'Noto Sans JP', sans-serif;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.79;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
      }
    }
  }
}
</style>
